// import * as React, from "react";
import React, { useEffect, useState, useRef } from "react";

// React Bootstrap
import { Dropdown, Offcanvas } from 'react-bootstrap';


// Import Slider

// Import Components

// Import Images
import logoWhite from '../assets/images/logo-white.svg'
import bannerBgImg from '../assets/images/crypto-banner-img-dektop.png'
import bannerBgImgMobile from '../assets/images/crypto-banner-img-mobile.png'
import bannerBgMobileImg from '../assets/images/landing-banner-bg-mobile-img.png'
import custodianWalletImg from '../assets/images/custodian-wallet-img.svg'
import hardwareWalletImg from '../assets/images/hardware-wallet-img.svg'
import mobileWalletImg from '../assets/images/mobile-wallet-img.svg'
import isoLogoImg from '../assets/images/iso-logo-img.png'
import fiatLogoImg from '../assets/images/fiat-logo-img.png'
import securityImg from '../assets/images/security-img.png'
import footerBgImg from '../assets/images/footer-bg-img.png'
import footerBgMobileImg from '../assets/images/footer-bg-mobile-img.png'

import tradingDeskImg1 from '../assets/images/trading-desk-img-1.png'
import tradingDeskImg2 from '../assets/images/trading-desk-img-2.png'
import cryptoGlobalImg from '../assets/images/crypto-global-img.png'
import linkedinGrayIcon from '../assets/images/icons/linkedin-light-gray-icon.svg'
import youtubeGrayIcon from '../assets/images/icons/youtube-light-gray-icon.svg'
import xGrayIcon from '../assets/images/icons/x-light-gray-icon.svg'

// Import Icons
import offerIcon from "../assets/images/icons/offer-black-icon.svg";
import menuBarIcon from "../assets/images/icons/hamburger-menu-white.svg";
import Google from './auth/Clientlogin/Google';


function CryptoPage() {
    const [openMenu, setOpenMenu] = useState(false);
    const [user, setUser] = useState(null);
    const [showLogin, setShowLogin] = useState(false);

    useEffect(() => {
        document.body.classList.add("landing-page-body");
        // Cleanup: Remove the class when the component unmounts or route changes
        return () => {
            document.body.classList.remove("landing-page-body");
        };
    });

    const toggleMenu = () => {
        setOpenMenu(prev => !prev);
    };

    useEffect(() => {
        const s = sessionStorage.getItem("logedinUser");
        if (s) {
            try {
                setUser(JSON.parse(s));
            } catch {
                setUser(null);
            }
        }
    }, []);

    const openLoginModal = (e) => {
        e.preventDefault();
        setShowLogin(true);
    };

    const closeLoginModal = () => {
        setShowLogin(false);
    };

    const logout = (e) => {
        e.preventDefault();
        sessionStorage.clear();
        setUser(null);
    };


    return (
        <div className='home-page'>

            <div className={`landing-header ${openMenu ? 'menu-open' : ''}`}>
                <div className="header-wrapper">
                    <div className="logo-wrapper">
                        <a href="#" className="logo">
                            <img src={logoWhite} alt="logo" />
                        </a>
                    </div>
                    <div className="navbar-menu">
                        <div className="menu-bar">
                            <img src={menuBarIcon} onClick={toggleMenu} alt="icon" />
                        </div>
                        <ul className={`menu ${openMenu ? 'active' : ''}`}>

                            {user ? (<>
                                <li><a href="/home-page">Custodian</a></li>
                                <li><a href="/otc-trade">Crypto On/Off Ramp</a></li>
                                <li><a href="#" onClick={logout}>Log Out</a></li>
                                <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSfyLCFpon7IoxePRa7OFUKg6aVaNsQwk6tq5KnffmjOYo-P8w/viewform?usp=sharing&ouid=101029151568667190819" target="_blank" rel="noopener noreferrer">Schedule a Demo</a></li>
                                <li>
                                    <div className="dropdown-v1">
                                        <Dropdown>
                                            <Dropdown.Toggle>
                                                <img width="40px" height="40px" src={user.picture} alt="User profile" />
                                            </Dropdown.Toggle>
                                            {/* <Dropdown.Menu>
                                                <Dropdown.Item href="/" onClick={logout}>Log out</Dropdown.Item>
                                            </Dropdown.Menu> */}
                                        </Dropdown>
                                    </div>
                                </li>
                            </>
                            ) : (<>
                                <li><a href="#" onClick={openLoginModal}>Custodian</a></li>
                                <li><a href="#" onClick={openLoginModal}>Crypto On/Off Ramp</a></li>
                                <li><a href="#" onClick={openLoginModal}>Log In</a></li>
                                <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSfyLCFpon7IoxePRa7OFUKg6aVaNsQwk6tq5KnffmjOYo-P8w/viewform?usp=sharing&ouid=101029151568667190819" target="_blank" rel="noopener noreferrer">Schedule a Demo</a></li>
                            </>
                            )}

                        </ul>
                    </div>
                </div>
            </div>

            <Offcanvas show={showLogin} onHide={closeLoginModal} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Log In</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ul className="btn-list">
                        <Google />
                    </ul>
                </Offcanvas.Body>
            </Offcanvas>

            <section className="sec-crypto-banner">
                <div className="container-fluid">
                    <div className="banner-wrapper">
                        <div className="banner-img">
                            <img src={bannerBgImg} alt="img" className="bg-img d-none d-md-block" />
                            <img src={bannerBgImgMobile} alt="img" className="bg-img d-block d-md-none" />
                            {/*<ul className="crypto-list">
                                <li><a href="#" className="btn-style transparent">FIAT CURRENCIES</a></li>
                                <li><a href="#" className="btn-style transparent">CRYPTO CURRENCIES</a></li>
                            </ul>*/}
                        </div>

                        <div className="banner-content">
                            <h1 className="title-style-01 d-none d-md-block">Crypto On/Off Ramp & OTC Trading - <br />Backed by <b>Swiss-Level Trust</b> and <br /> <b>Compliance.</b></h1>
                            <h1 className="title-style-01 d-block d-md-none">Crypto On/Off Ramp & OTC<br /> Trading - <br /> Backed by <b>Swiss-Level Trust</b> <br /> and <b>Compliance.</b></h1>
                            <h3>Seamlessly convert between crypto and fiat with institutional-grade execution, deep <br /> liquidity, and full regulatory compliance - all on one trusted platform.</h3>
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style transparent">Schedule a Demo</a></li>
                                {user ? (
                                    <li><a href="#" className="btn-style transparent" onClick={logout}>Log Out</a></li>
                                ) : (
                                    <li><a href="#" className="btn-style transparent" onClick={openLoginModal}>Log In</a></li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sec-otc-trading-desk">
                <div className="container p-lr-40">
                    <h2 className="title-style-01 d-none d-md-block">OTC Trading Desk. <br />
                        <b>Institutional Execution</b> & <b>Zero Slippage.</b></h2>
                    <div className="desk-grid">
                        <div className="desk-card">
                            <div className="content-wrapper">
                                <h3 className="f-24">Seamless Conversion</h3>
                                <p className="f-22">Convert fiat to crypto or crypto to crypto in a single click.</p>
                            </div>
                            <div className="img-wrapper">
                                <img src={tradingDeskImg1} alt="img" />
                            </div>
                        </div>
                        <div className="desk-card">
                            <div className="content-wrapper">
                                <h3 className="f-24">Unmatched Trade Stability</h3>
                                <p className="f-22">Access deep liquidity, competitive execution, and efficient settlement with no market slippage.</p>
                            </div>
                            <div className="img-wrapper">
                                <img src={tradingDeskImg2} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sec-crypto-global">
                <div className="container p-lr-40">
                    <div className="sec-heading">
                        <h2 className="title-style-01 lh-same">Our infrastructure enables instant, direct conversions between local currencies and digital assets</h2>
                        <h3>securely, transparently, and without intermediaries</h3>
                    </div>
                    <div className="map-img">
                        <img src={cryptoGlobalImg} alt="img" />
                    </div>
                </div>
            </section>

            <section className="sec-join-partner">
                <div className="container p-lr-40">
                    <div className="content-wrapper">
                        <h2 className="title-style-01 lh-same">Partner with DORU.CO - <br />
                            Built for Institutions</h2>
                        <p className="f-20">Join early adopters integrating with DORU.CO for seamless access to compliant crypto infrastructure. Collaborate across custody, hardware, mobile, and payment solutions to expand your institutional capabilities.</p>
                        <ul className="btn-list">
                            <li><a href="#" className="btn-style white">Schedule a Demo</a></li>
                            <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSfkq2Ee_T6re7jFLQpCTH52Cr5Q2Lzgq-lUc6YKyAw7tuhRNw/viewform" target="_blank" rel="noopener noreferrer" className="btn-style white">Join the Early Adopter Program </a></li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sec-crypto-faqs">
                <div className="container p-lr-40">
                    <h2 className="title-style-01">Frequently Asked Questions</h2>
                    <div className="faq-wrapper">
                        <div className="accordion" id="accordionWidget2">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2.1" aria-expanded="false" aria-controls="collapse2.1">
                                        Convert fiat, crypto or crypto,crypto in a single click?
                                    </button>
                                </h2>
                                <div id="collapse2.1" className="accordion-collapse collapse" data-bs-parent="#accordionWidget2">
                                    <div className="accordion-body">
                                        <p>We help you use AI across your business to work smarter. From analyzing your systems and data to automating tasks and improving decision-making, we unlock the full value of custom AI for your company.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2.2" aria-expanded="false" aria-controls="collapse2.2">
                                        Convert fiat, crypto or crypto,crypto in a single click?
                                    </button>
                                </h2>
                                <div id="collapse2.2" className="accordion-collapse collapse" data-bs-parent="#accordionWidget2">
                                    <div className="accordion-body">
                                        <p>Quickly build and test custom AI ideas with Kustom's expert team. We help you create a working proof of concept (POC) to kickstart your AI journey and show fast, clear results.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2.3" aria-expanded="false" aria-controls="collapse2.3">
                                        Convert fiat, crypto or crypto,crypto in a single click?
                                    </button>
                                </h2>
                                <div id="collapse2.3" className="accordion-collapse collapse" data-bs-parent="#accordionWidget2">
                                    <div className="accordion-body">
                                        <p>Solutions are designed to tackle major organizational challenges. At Kustom AI, our refined approach—combining research, design, and development—creates cutting-edge digital solutions powered by the latest technologies and AI models.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="crypto-landing-footer">
                <img src={footerBgImg} alt="img" className="bg-img d-none d-md-block" />
                <img src={footerBgMobileImg} alt="img" className="bg-img d-block d-md-none" />
                <div className="container">
                    <div className="content-wrapper">
                        <ul className="link-list">
                            {user ? <li><a href="/otc-trade">Crypto On/Off Ramp</a></li> :
                                <li><a href="#" onClick={openLoginModal}>Crypto On/Off Ramp</a></li>}
                            {!user && <li><a href="#" onClick={openLoginModal}>Log In</a></li>}
                            <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSfyLCFpon7IoxePRa7OFUKg6aVaNsQwk6tq5KnffmjOYo-P8w/viewform?usp=sharing&ouid=101029151568667190819" target="_blank" rel="noopener noreferrer">Schedule a Demo</a></li>
                            <li><a href="#">Partnership Opportunity</a></li>
                            <li><a href="#">About Doru</a></li>
                            <li><a href="#">FAQ</a></li>
                        </ul>
                        <ul className="link-list">
                            <li><a href="/crypto-legal">Legal</a></li>
                            <li><a href="/crypto-legal">Website Terms of Service</a></li>
                            <li><a href="/crypto-legal">Privacy Policy</a></li>
                            <li><a href="/crypto-legal">Disclaimer</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* <div className="crypto-landing-bottom-footer">
                <div className="container">
                    <div className="content-wrapper">
                        <p className="p">Products developed in the XDC Innovation Lab.</p>
                        <ul className="social-list">
                            <li><a href="#" target="_blank"><img src={linkedinGrayIcon} alt="icon" /></a></li>
                            <li><a href="#" target="_blank"><img src={youtubeGrayIcon} alt="icon" /></a></li>
                            <li><a href="#" target="_blank"><img src={xGrayIcon} alt="icon" /></a></li>
                        </ul>
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default CryptoPage
